import React from "react";
import AntdImage, {ImageProps} from 'antd/lib/image';
import { withError} from '@fishx/tracker';

const PreviewGroup = AntdImage.PreviewGroup;
interface FCImageProps extends React.FC<ImageProps> {
  PreviewGroup: typeof PreviewGroup;
}
const Image: FCImageProps = (props) => {
  return (
    <AntdImage {...props} />
  )
}
Image.PreviewGroup = PreviewGroup;
Image.displayName = 'Image';
export default withError(Image);


// WEBPACK FOOTER //
// ./src/components/image/index.tsx